/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class ExpPlugin extends FunctionPlugin {
    /**
     * Corresponds to EXP(value)
     *
     * Calculates the exponent for basis e
     *
     * @param ast
     * @param formulaAddress
     */
    exp(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('EXP'), Math.exp);
    }
}
ExpPlugin.implementedFunctions = {
    'EXP': {
        method: 'exp',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER }
        ],
    },
};
